import Footer from "../../components/feature/Footer";
import Header from "../../components/feature/Header";
import WhatsAppFloat from "../../components/feature/WhatsAppFloat";
import ContactSection from "../home/components/ContactSection";

const plans = [
  {
    name: "Plano Inicial",
    subtitle: "Virtualização Essencial",
    description:
      "Ideal para empresas que desejam migrar seus servidores locais para o data center da Invictus com segurança e performance.",
    includes: [
      "Virtualização de 1 a 2 servidores",
      "Infraestrutura em data center Tier 3",
      "Backup diário com retenção de 7 dias",
      "Monitoramento básico com alertas",
      "Suporte técnico em horário comercial",
      "Proteção com firewall Sophos",
    ],
    benefits: [
      "Eliminação de servidores físicos locais",
      "Redução de custos com manutenção e energia",
      "Maior segurança e disponibilidade dos dados",
      "Ambiente profissional com redundância e refrigeração adequada",
    ],
  },
    {
    name: "Plano Completo",
    subtitle: "Invictus TotalCare TI",
    description:
      "Terceirização completa da TI com foco em performance, segurança e tranquilidade operacional.",
    includes: [
      "Virtualização completa de servidores e desktops",
      "Gestão de toda a infraestrutura de TI",
      "Backup com retenção de 30 dias e replicação geográfica",
      "Monitoramento proativo e gestão de incidentes",
      "Suporte técnico 24/7 com SLA personalizado",
      "Consultoria contínua de segurança e compliance",
      "Gestão de licenças, atualizações e patches",
      "Relatórios mensais de performance e segurança",
    ],
    benefits: [
      "Foco total no negócio, sem preocupações com TI",
      "Equipe técnica especializada à disposição",
      "Segurança de nível corporativo com replicação geográfica",
      "Prevenção de falhas com monitoramento proativo",
      "Conformidade com LGPD e boas práticas de TI",
      "Planejamento estratégico contínuo com apoio técnico",
    ],
    featured: true,
  },
  {
    name: "Plano Intermediário",
    subtitle: "Virtualização Avançada",
    description:
      "Para empresas que precisam de alta disponibilidade e querem virtualizar servidores e desktops com segurança e mobilidade.",
    includes: [
      "Virtualização de servidores e desktops (Citrix)",
      "Acesso remoto seguro via Netscaler",
      "Backup diário com retenção de 15 dias",
      "Monitoramento avançado com SolarWinds",
      "Suporte técnico 24/7",
      "Proteção com firewall Sophos e antivírus gerenciado",
      "Licenciamento Microsoft 365 Standard incluso",
    ],
    benefits: [
      "Mobilidade total para equipes internas e externas",
      "Redução de riscos com acesso remoto seguro",
      "Alta performance com desktops virtuais otimizados",
      "Ambiente monitorado e protegido contra ameaças",
      "Produtividade com ferramentas Microsoft integradas",
    ],
  },

];


export default function PricingPage() {
    return (
    <div className="min-h-screen bg-white">
      <Header />

<main className="py-8 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <h1 className="text-5xl font-bold mb-6 text-gray-800">
          Planos de Virtualização Invictus
        </h1>
        <p className="text-gray-600 mb-16 max-w-3xl mx-auto">
          Compare nossos planos e descubra o nível ideal de performance, segurança e suporte
          para a infraestrutura da sua empresa.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
          <div className="md:col-span-3">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {plans.map((plan) => (
                <div
                  key={plan.name}
                  className={`rounded-2xl shadow-lg border transition-all duration-300 overflow-hidden ${
                    plan.featured
                      ? "bg-blue-600 text-white scale-105 shadow-2xl"
                      : "bg-white text-gray-800 hover:shadow-xl"
                  }`}
                >
                  <div className="p-8">
                    <h3
                      className={`text-2xl font-bold ${
                        plan.featured ? "text-white" : "text-blue-600"
                      }`}
                    >
                      {plan.name}
                    </h3>
                    <p className="text-lg font-medium mb-4">{plan.subtitle}</p>
                    <p className={`mb-6 ${plan.featured ? "text-blue-100" : "text-gray-600"}`}>
                      {plan.description}
                    </p>

                    <div className="text-left">
                      <h4 className={`font-semibold mb-2 ${plan.featured ? "text-white" : "text-gray-800"}`}>
                        Inclui:
                      </h4>
                      <ul className="list-disc list-inside mb-4 space-y-1 text-sm">
                        {plan.includes.map((item, i) => (
                          <li key={i} className={`${plan.featured ? "text-blue-100" : "text-gray-700"}`}>
                            {item}
                          </li>
                        ))}
                      </ul>

                      <h4 className={`font-semibold mb-2 ${plan.featured ? "text-white" : "text-gray-800"}`}>
                        Benefícios:
                      </h4>
                      <ul className="list-disc list-inside space-y-1 text-sm">
                        {plan.benefits.map((b, i) => (
                          <li key={i} className={`${plan.featured ? "text-blue-100" : "text-gray-700"}`}>
                            {b}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </main>

      <footer className="bg-slate-900 text-white">
        <ContactSection />
        <Footer />
      </footer>

      <WhatsAppFloat />
    </div>
  );
    
}
